import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const allotImprestApi = (payload) =>
  axios.post(`${API_BASE_URL}/api/imprest/allot`, payload);

export const bookImprestExpenseApi = (payload) =>
  axios.post(`${API_BASE_URL}/api/imprest/expense`, payload);

export const updateImprestEntryApi = (id, payload) =>
  axios.patch(`${API_BASE_URL}/api/imprest/${id}`, payload);

export const deleteImprestEntryApi = (id) =>
  axios.delete(`${API_BASE_URL}/api/imprest/${id}`);
